import api from 'api';

export const loadAffiliates = api('GET /api/campaigns/fields/affiliates');
export const loadApplications = api('GET /api/campaigns/fields/applications');
export const loadNetworks = api('GET /api/campaigns/fields/networks');

export const loadPlatforms = api('GET /api/campaigns/fields/platforms');
export const loadDummyPlatforms = api(
  'GET /api/campaigns/fields/dummyPlatforms'
);

export const loadLocales = api('GET /api/campaigns/fields/locales');
export const loadDomains = api('GET /api/campaigns/fields/domains');
export const loadCountries = api('GET /api/campaigns/fields/countries');
export const loadAudiences = api('GET /api/campaigns/fields/audiences');
export const loadConversionPageFlows = api(
  'GET /api/campaigns/fields/conversion-page-flows'
);
export const loadConversionPages = api(
  'GET /api/campaigns/fields/conversion-pages'
);

export const loadLabels = api('GET /api/campaigns/fields/labels');
export const loadLinkFormats = api('GET /api/campaigns/fields/link-formats');

export const loadActiveUsers = api('GET /api/campaigns/fields/active-users');
export const loadUsers = api('GET /api/campaigns/fields/users');

export const loadCostModels = api('GET /api/campaigns/fields/cost-models');
export const loadCostModelCurrencies = api(
  'GET /api/campaigns/fields/cost-model/currencies'
);

export const loadRewardPackages = api(
  'GET /api/campaigns/fields/deeplinks/reward-packages'
);
export const loadLocations = api(
  'GET /api/campaigns/fields/deeplinks/locations'
);

export const loadDeepLinkConfig = api('GET /api/campaigns/deeplinks/config');

export const loadSubLocations = api(
  'GET /api/campaigns/fields/deeplinks/sub-locations'
);
export const loadFraudProtectionCountries = api(
  'GET /api/campaigns/fields/fraud-protection/countries'
);

export const loadFraudProtectionDeviceTypes = api(
  'GET /api/campaigns/fields/fraud-protection/device-types'
);

export const loadFraudProtectionOperators = api(
  'GET /api/campaigns/fields/fraud-protection/operators'
);
export const loadFraudProtectionOsVersions = api(
  'GET /api/campaigns/fields/fraud-protection/os-versions'
);

export const loadPromoCodes = api('POST /api/campaigns/fields/promo-codes'); //For create form (Multi campaign form)

export const loadPromoCodesAll = api(
  'POST /api/campaigns/fields/promo-codes/all'
);

export const loadGGLinks = api('POST /api/campaigns/gg-links');

export const loadEvents = api('GET /api/campaigns/fields/events');

export const loadCampaignActivityTypes = api(
  'GET /api/campaigns/fields/targetingactivitytypes'
);
export const loadMediaSources = api('GET /api/campaigns/fields/media-sources');

export const loadTargetUsers = api('GET /api/campaigns/fields/target-users');

export const loadCostModelsEvents = api('GET /api/campaigns/fields/events/:id');

export const loadAdditionalRewardConditions = api(
  'GET /api/campaigns/fields/reward-packages-conditions'
);

export const loadRewards = api('GET /api/campaigns/fields/reward-packages');

export const loadAdditionalRewards = api(
  'GET /api/campaigns/fields/reward-packages-additional'
);

export const loadIOSLandingPages = api(
  'GET /api/campaigns/fields/conversion-pages'
);

export const loadAndroidLandingPages = api(
  'GET /api/campaigns/fields/conversion-pages'
);

export const loadLinksConfig = api('GET /api/campaigns/fields/linkTypesConfig');

export const loadInitialTrackRe = api(
  'GET /api/campaigns/fields/track-re-initial'
);

export const loadFraudProtections = api(
  'GET /api/campaigns/fields/fraud-protections'
);

export const loadSpendAllocationType = api(
  'GET /api/campaigns/fields/spend-allocation-types'
);
